import React, { Component } from 'react'
import ConfiguratorSection from './../ConfiguratorSection'
import X46MK2ConfiguratorImageWithOverlays from './X46MK2ConfiguratorImageWithOverlays'
import ConfiguratorOption from './../ConfiguratorOption'
import RadioGroup from './../RadioGroup'
import { withTranslation, Trans } from 'react-i18next'
import { exteriorView08ImageOptions } from './views/ExteriorView08'

class X46MK2Mast extends Component {
  constructor (props) {
    super(props)
    this.handleMastAndBoomChange = this.handleMastAndBoomChange.bind(this)
    this.handleSelfTackerChange = this.handleSelfTackerChange.bind(this)
  }

  handleMastAndBoomChange (newValue) {
    let configuration = this.props.configuration
    configuration.MastAndBoom = newValue

    if (this.props.onChange) {
      this.props.onChange(configuration)
    }
  }

  handleSelfTackerChange (newValue) {
    let configuration = this.props.configuration
    configuration.SelfTacker = newValue

    if (this.props.onChange) {
      this.props.onChange(configuration)
    }
  }

  render () {
    let imageOptions = exteriorView08ImageOptions

    let image = (
      <X46MK2ConfiguratorImageWithOverlays
        boat='X46MK2'
        configuration={this.props.configuration}
        options={imageOptions}
      />
    )

    return (
      <ConfiguratorSection image={image}>
        <ConfiguratorOption>
          <h1>
            <Trans defaults='Mast & boom' />
          </h1>

          <h2>
            <Trans defaults='Finish' />
          </h2>

          <RadioGroup
            options={this.props.mastAndBoomOptions}
            value={this.props.configuration.MastAndBoom}
            onChange={this.handleMastAndBoomChange}
          />

          <p>
            <Trans defaults='**for optional furlerboom, please contact your local X-Yachts Dealer.' />
          </p>

          <h2>
            <Trans defaults='Selftacking Track' />
          </h2>

          <p>
            <Trans defaults='Self Tacking track recessed ‐ into the coachroof, curved track and Toulon ball bearing traveller, single sheet led aft via the mast to halyard winch (one side).' />
          </p>

          <RadioGroup
            options={this.props.selfTackerOptions}
            value={this.props.configuration.SelfTacker}
            onChange={this.handleSelfTackerChange}
          />
        </ConfiguratorOption>
      </ConfiguratorSection>
    )
  }
}

export default withTranslation()(X46MK2Mast)



// WEBPACK FOOTER //
// ./src/X46MK2/X46MK2Mast.js